import { render, staticRenderFns } from "./community_industry.vue?vue&type=template&id=0223807f&scoped=true&"
import script from "./community_industry.vue?vue&type=script&lang=js&"
export * from "./community_industry.vue?vue&type=script&lang=js&"
import style0 from "./community_industry.vue?vue&type=style&index=0&id=0223807f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223807f",
  null
  
)

export default component.exports